export default __webpack_public_path__ + "static/media/flank.c33f1856.jpg";